var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11505 9.88834C5.86742 9.64071 5.67099 9.34673 5.53698 9.02319C5.40296 8.69965 5.33398 8.35287 5.33398 8.00267C5.33398 7.65247 5.40296 7.3057 5.53698 6.98216C5.67099 6.65861 5.86742 6.36464 6.11505 6.11701C6.36268 5.86938 6.65666 5.67295 6.9802 5.53893C7.30375 5.40491 7.65052 5.33594 8.00072 5.33594C8.35092 5.33594 8.69769 5.40491 9.02124 5.53893C9.34478 5.67295 9.63876 5.86938 9.88639 6.11701",
    stroke: "#584E63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52972 8.47266L7.64572 8.63732C8.30517 9.52898 9.24235 10.1761 10.3098 10.4768C11.3773 10.7776 12.5144 10.7149 13.5424 10.2987C13.1641 11.209 12.5673 12.0121 11.8048 12.6369C11.0423 13.2618 10.1376 13.6891 9.17069 13.8811C8.20377 14.0732 7.20442 14.024 6.26102 13.738C5.31761 13.452 4.45921 12.938 3.76172 12.2413",
    stroke: "#584E63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H2.66667",
    stroke: "#584E63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2V2.66667",
    stroke: "#584E63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7334 3.73438L4.20007 4.20104",
    stroke: "#584E63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14L14 2",
    stroke: "#584E63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.24acda8f5421f4dd3178522100e52be5.svg";
export { ForwardRef as ReactComponent };